import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PolicyService, PolicyData } from '../services/policy.service';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../landing-page/landing-page.component.css', './privacy-policy.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatProgressSpinnerModule]
})
export class PrivacyPolicyComponent implements OnInit {
  isLoginDropdownOpen = false;
  policyData: PolicyData | null = null;
  isLoading = true;

  constructor(
    private router: Router,
    private policyService: PolicyService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.policyService.getPolicy('privacy').subscribe(data => {
      this.policyData = data;
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleLoginDropdown(): void {
    this.isLoginDropdownOpen = !this.isLoginDropdownOpen;
  }

  adminportal(): void {
    this.router.navigate(['/account/login']);
  }

  candidateportal(): void {
    this.router.navigate(['/candidate']);
  }

  navigateToContactUs(): void {
    this.router.navigate(['/contact-us']);
  }
}
